import { inject, InjectionToken } from "@angular/core";
import { Route } from "@angular/router";
import { DynamicTabsService } from "@app/shared-core/general/dynamic-tabs/dynamic-tabs.service";
import { StockNotificationSettingsRoutePaths } from "../stock-notification-settings-route-path";
import { NotificationSettingsRoutePaths } from "@app/applications/settings/domains/notification-settings/notification-settings-route-path";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";
import { stockNotificationSettingsRoutes } from "../stock-notification-settings.routes";
import { PERMISSION_CONSTANTS } from "@app/shared/auth/constants/permissions.constant";

export const stockNotificationSettingsDynamicRoutesConfig: Route[] = [
  {
    path: NotificationSettingsRoutePaths.ROOT,
    children: [
      {
        path: "",
        children: stockNotificationSettingsRoutes,
      },
    ],
  },
];

export const ADD_STOCK_NOTIFICATION_SETTINGS_TABS = new InjectionToken("ADD_STOCK_NOTIFICATION_SETTINGS_ROUTES", {
  providedIn: "root",
  factory: () => {
    inject(DynamicTabsService).addTabs(
      NotificationSettingsRoutePaths.ROOT,
      [
        {
          route: StockNotificationSettingsRoutePaths.ROOT,
          label: "STOCK_NOTIFICATION_SETTINGS.TITLES.STOCK_NOTIFICATION_SETTINGS",
          permissions: [PERMISSION_CONSTANTS.STOCK_NOTIFICATION_SETTINGS.VIEW, PERMISSION_CONSTANTS.STOCK_NOTIFICATION_SETTINGS.SET],
        },
      ],
      { parentRoutePath: APP_ROUTE_PATHS.SETTINGS, routes: stockNotificationSettingsDynamicRoutesConfig }
    );
  },
});
